import Swiper from "swiper";
import GenericSlider from "../components/GenericSlider";
import { api } from "../API";
import { $t } from "../i18n";

import Vue from "vue";
import FaqWrap from "../vue/Faq/FaqWrap.vue";
import FaqList from "../vue/Faq/FaqList.vue";
import FaqItem from "../vue/Faq/FaqItem.vue";
import FaqItemHeader from "../vue/Faq/FaqItemHeader.vue";

export default {
  init() {
    const hotelsGallery = $(".hotel-gallery");
    const infoGallery = $(".site-info-gallery");
    const infos = $(".infos-tab");
    const hotelsAnchorLink = $(".site-single-main a.hotels-anchor");
    const readMoreAnchor = $(".site-single-main a.readmore");
    const hotelsSection = $(".site-single-hotels");
    const aboutSection = $(".site-single-info");
    let swipersHotel = [];
    let swipersInfo = [];

    // Tab slider logic (header tab switch)
    if ($("#site-header-tab-slider").html() != null) {
      const $toolbar = $(".tab-slider-toolbar");

      $toolbar.find("li").click(function () {
        if ($(this).data("link")) return;

        $("html, body").animate({
          scrollTop: $tabSlider.offset().top - 100 + "px",
          duration: 200,
        });

        self.tabSlider.activateTab($(this).data("tab-id"));
      });

      $(window).scroll(function () {
        const $windowTop = $(window).scrollTop();
        const $sliderInterceptElm = $(".app-page-header.single-site");

        if ($windowTop > $sliderInterceptElm.offset().top) {
          $toolbar.addClass("active");
        } else {
          $toolbar.removeClass("active");
        }
      });
    }

    function popupWindow(url, title, win, w, h) {
      const y = win.top.outerHeight / 2 + win.top.screenY - h / 2;
      const x = win.top.outerWidth / 2 + win.top.screenX - w / 2;
      return win.open(
        url,
        title,
        `toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=${w}, height=${h}, top=${y}, left=${x}`
      );
    }

    $("a.iframe-link").on("click", function (e) {
      e.preventDefault();
      const link = $(this).attr("href");
      popupWindow(link, link, window, 700, 400);
    });

    const fetchHotelExtras = (hotelID) => {
      if (
        !api.REQUESTING_EXTRA_CONTENTS ||
        parseInt(hotelID) !== parseInt(api.REQUESTING_EXTRA_CONTENTS)
      ) {
        $(".extra-contents-modal").modal().showLoader();
        $(".extra-contents-modal ul.hotel-package-list").html("");

        api.hotelsExtraContents(hotelID).then((extras) => {
          $(".extra-contents-modal").modal().hideLoader();
          api.REQUESTING_EXTRA_CONTENTS = false;
          $(".extra-contents-modal ul.hotel-package-list").html("");
          extras.forEach((extra) => {
            $(".extra-contents-modal ul.hotel-package-list").append(
              `<li>${extra}</li>`
            );
          });
        });
      }
    };

    $("li.extra-package").on("click", function (e) {
      e.preventDefault();
      fetchHotelExtras($(this).data("hotel"));
    });

    $("a.site-toggle-video").on("click", function (e) {
      e.preventDefault();
      const iframe = $(this).data("iframe");

      $(this).toggleClass("video-thumbnail");
      $(this).find("img").hide();

      $(this).append(iframe);
      $(this).find("iframe").show();
    });

    $(document).on(
      "click",
      ".available-packages-dates a.show-all",
      function (e) {
        e.preventDefault();
        $(this).text(
          $(this).hasClass("active") ? $t("הצג הכל") : $t("הצג פחות")
        );
        $(this).toggleClass("active");
        $(".available-packages-dates table tr.hidden-package-row").toggle();
      }
    );

    window.addEventListener("message", function (message) {
      if (message.data && message.data.event === "offer-sent") {
        const url = message.data.url;
        const iframe = $(".agent-offer-iframe");
        iframe.find("iframe").attr("src", "");
        iframe.toggleClass("active");

        const popup = $(".quote-success-modal");
        popup.find("a").attr("href", url);
        popup.addClass("active");
      }
    });

    hotelsAnchorLink.on("click", (e) => {
      e.preventDefault();
      const header =
        $(window).width() > 1024
          ? 0
          : jQuery(".site-header-mobile")[0].scrollHeight;

      $("html, body").animate(
        {
          scrollTop: hotelsSection.offset().top - header,
        },
        250
      );
    });

    readMoreAnchor.on("click", (e) => {
      e.preventDefault();
      $("html, body").animate(
        {
          scrollTop: aboutSection.offset().top,
        },
        250
      );
    });

    $(".hotel-gallery-swiper").each((idx, el) => {
      const element = $(el);
      const elementParent = $(el).parent();

      element.attr("data-idx", idx);
      element.addClass("swiper-initialized");

      setTimeout(() => {
        const swiper = new Swiper(element, {
          slidesPerView: 1,
          loop: true,
          lazy: false,
          pagination: {
            el: elementParent.find(".swiper-pagination"),
          },
          navigation: {
            nextEl: elementParent.find(".swiper-button-next"),
            prevEl: elementParent.find(".swiper-button-prev"),
          },
          on: {
            slideChange() {
              const activeIndex = $(this)[0].activeIndex;
              const desc = jQuery($(this)[0].slides[activeIndex]).attr(
                "data-description"
              );
              elementParent.find(".slider-description").html(desc);
              $(this)[0].allowTouchMove = true;
              $(this)[0].update();
            },
            init() {
              const firstSlide = jQuery(
                jQuery($(this)[0].slides).filter(
                  "[data-swiper-slide-index='0']"
                )[0]
              );
              const desc = firstSlide.attr("data-description");
              elementParent.find(".slider-description").html(desc);
            },
          },
        });
        swipersHotel.push(swiper);
      }, 400);
    });

    $(".hotel-links").on("site_tabs_clicked", function (e, target, hotelId) {
      const el = $(target).find(".hotel-gallery-swiper");
      const slider = swipersHotel[el.data("idx")];

      setTimeout(() => {
        if (slider) {
          slider.update();
          const firstSlide = jQuery(
            jQuery($(slider)[0].slides).filter(
              "[data-swiper-slide-index='0']"
            )[0]
          );
          const desc = firstSlide.attr("data-description");
          jQuery(slider.el).parent().find(".slider-description").html(desc);
        }
      }, 1000);

      if (!api.REQUESTING_HOTEL_PACKAGES.includes(hotelId)) {
        api
          .hotelPackages(
            hotelId,
            window.userId,
            window.postId,
            window.siteData.customer.group
          )
          .then((res) => {
            const datesElem = $(".available-hotel-dates-" + hotelId);
            datesElem.html(res.html);
            datesElem.addClass("loaded");
          })
          .catch((err) => console.log(err));
      }

      window.location.hash = `${hotelId}`;
    });

    $(".info-links").on("site_tabs_clicked", function () {
      swipersInfo.forEach((slide) => {
        slide.update();
      });
    });

    function GetParameterValues(param) {
      const url = window.location.href
        .slice(window.location.href.indexOf("?") + 1)
        .split("&");
      for (let i = 0; i < url.length; i++) {
        const urlparam = url[i].split("=");
        if (urlparam[0] == param) return urlparam[1];
      }
    }

    $(window).on("load", () => {
      if (GetParameterValues("show_hotels")) {
        const header =
          $(window).width() > 1024
            ? 0
            : jQuery(".site-header-mobile")[0].scrollHeight;
        const hotelsSection = $(".site-single-hotels");
        $("html, body").animate(
          {
            scrollTop: hotelsSection.offset().top - header,
          },
          250
        );
      }

      $("#site-header-tab-slider-hotels").on("click", () => {
        const header =
          $(window).width() > 1024
            ? 0
            : jQuery(".site-header-mobile")[0].scrollHeight;
        const hotelsSection = $(".site-single-hotels");
        $("html, body").animate(
          {
            scrollTop: hotelsSection.offset().top - 40 - header,
          },
          250
        );
      });

      $("#site-header-tab-slider-siteinfo").on("click", () => {
        const header =
          $(window).width() > 1024
            ? 0
            : jQuery(".site-header-mobile")[0].scrollHeight;
        const hotelsSection = $(".site-single-info");
        $("html, body").animate(
          {
            scrollTop: hotelsSection.offset().top - 80 - header,
          },
          250
        );
      });

      infoGallery.each((idx, elem) => {
        const swiper = new Swiper($(elem).find(".swiper-container"), {
          slidesPerView: 1,
          pagination: {
            el: $(elem).find(".swiper-pagination"),
          },
          navigation: {
            nextEl: $(elem).find(".swiper-button-next"),
            prevEl: $(elem).find(".swiper-button-prev"),
          },
        });
        swipersInfo.push(swiper);
      });

      new Swiper($(".site-special-links-mobile"), {
        slidesPerView: 3,
      });

      const swiperInfos = new Swiper(infos.find(".site-info-swiper"), {
        slidesPerView: 6,
        spaceBetween: 23,
        navigation: {
          nextEl: infos.find(".info-links-btn-next"),
        },
        breakpoints: {
          1200: {
            slidesPerView: 5,
          },
          950: {
            slidesPerView: 4,
          },
          767: {
            slidesPerView: 3,
            spaceBetween: 0,
          },
        },
      });

      if (
        $(".site-info-swiper .swiper-slide").length <=
        swiperInfos.params.slidesPerView
      ) {
        infos.find(".info-links-btn-next").hide();
      }
    });

    // ✅ Mount Vue Components
    const faqWrapEl = document.getElementById("faq-search");
    if (faqWrapEl) {
      new Vue({
        el: "#faq-search",
        components: { FaqWrap },
        template: `<faq-wrap :faq="faq" />`,
        data() {
          return {
            faq: JSON.parse(faqWrapEl.dataset.faq || "[]"),
          };
        },
      });
    }

    const faqListEl = document.getElementById("faq-list");
    if (faqListEl) {
      new Vue({
        el: "#faq-list",
        components: { FaqList, FaqItem, FaqItemHeader },
        template: `<faq-list :questions="questions" :open-questions="[]" />`,
        data() {
          return {
            questions: JSON.parse(faqListEl.dataset.questions || "[]"),
          };
        },
      });
    }
  },

  finalize() {
    // Optional cleanup or JS for finalize step
  },
};
